import {AxiosInstance, getAuthHeaders} from './api';

export const getUserNotifications = async (id) => {
  const headers = getAuthHeaders();
  try {
    let response = await AxiosInstance.get(`/news/GetNotification/${id}`, {
      headers,
    });

    if (response.status === 200) {
      const {data} = response;
      if (data.data) {
        //filter out alreadyViewed notifications
        const list: any[] = data.data;
        return list.filter((notification) => {
          const logs: [] = notification.webNotificationLog;
          const alreadyViewed = logs.find((log: any) => log.userId === id && log.readDate !== null);
          return alreadyViewed ? false : true;
        });
      } else return [];
    }
  } catch (error) {
    return [];
  }
};

export const updateNotificationStatus = async (notificationId, status = true) => {
  const headers = {}; //getAuthHeaders();
  const data = {NewsIsActive: status};
  try {
    let response = await AxiosInstance.put(`/news/updatestatus/${notificationId}`, {...data}, {headers});

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error.response.data;
  }
};

export const markAsReadNotification = async (userId, notificationId) => {
  const headers = getAuthHeaders();
  const data = {NewsIsActive: true};
  try {
    let response = await AxiosInstance.put(`/news/SetNewsRead/${userId}/${notificationId}`, {...data}, {headers});

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error.response.data;
  }
};
